export default __webpack_public_path__ + "static/media/ico-semua.e36fdc5a.webp";